import { EditorObject } from '../models/editor-object.model';
import { Position2D } from '../models/other/position2D.model';

export function placingPositionCorrection(pos:Position2D, obj: EditorObject):Position2D {
    let posCorrected:Position2D = { x: 0, y: 0 };
    let rotation = obj.rotation();
    let rect = obj.getClientRect({});
    switch (rotation) {
        case 90:
            posCorrected.x = pos.x + rect.width;
            posCorrected.y = pos.y;
            break;
        case 180:
            posCorrected.x = pos.x + rect.width;
            posCorrected.y = pos.y + rect.height;
            break;
        case 270:
            posCorrected.x = pos.x;
            posCorrected.y = pos.y + rect.height;
            break;
        default:
            posCorrected.x = pos.x;
            posCorrected.y = pos.y;
            break;
    }
    return posCorrected;
}